import React from 'react';
import { Form, FormHandlers } from '@doveit/bricks';
import { BooleanString } from '../../../utils/boolean-string/booleanString';
import { WizardContact } from '../../../providers/api/dtos';

export interface LegalEntityAmlFormProps extends React.AriaAttributes {
  buyer: WizardContact,
  subjectLabel?: string,
  initialValues?: Partial<LegalEntityAmlFormModel>,
  loading?: boolean,
  disabled?: boolean,
  innerRef?: React.MutableRefObject<FormHandlers>,
  onSubmit: (values: LegalEntityAmlFormModel) => void,
}

export interface LegalEntityAmlFormModel {
  isCompanyHolder: BooleanString,
  notes: string,
}

const DEFAULT_INITIAL_VALUES: LegalEntityAmlFormModel = {
  isCompanyHolder: '',
  notes: '',
};

const LegalEntityAmlForm: React.FC<LegalEntityAmlFormProps> = ({
  buyer,
  subjectLabel,
  initialValues,
  ...rest
}) => {
  const mergedInitialValues = React.useMemo(() => ({
    ...DEFAULT_INITIAL_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      {...rest}
    >
      {({ values, setFieldValue }) => {
        const handleIsCompanyHolderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.value === 'false') {
            setFieldValue('notes', DEFAULT_INITIAL_VALUES.notes);
          }
        };

        return (
          <>
            <Form.Item size={{ MD: 1 / 2 }}>
              <Form.YesOrNotButtons
                aria-label="Campo per indicare se il soggetto è il titolare effettivo della società"
                label={`${buyer.name || subjectLabel || 'Il soggetto'} è il titolare effettivo della società${buyer.legal?.companyName ? ` ${buyer.legal.companyName}` : ''}?`}
                name="isCompanyHolder"
                onChange={handleIsCompanyHolderChange}
              />
            </Form.Item>

            {values.isCompanyHolder === 'true' && (
              <Form.Item>
                <Form.TextArea
                  name="notes"
                  aria-label="Campo per indicare eventuali note sull'antiriciclaggio"
                  label="Eventuali note sull'antiriciclaggio"
                  rows={5}
                />
              </Form.Item>
            )}
          </>
        );
      }}
    </Form>
  );
};

export default LegalEntityAmlForm;
